import { io } from 'socket.io-client';
import siteConfig from "../config/siteConfig";

export const socket = io(siteConfig.base_urls.ws(), {
    autoConnect: true,
    secure:false,
    path:'/socket.io/'
});